// extracted by mini-css-extract-plugin
export default {"copyright":"Copyright_copyright__dyYNq"};